// Copyright ©️ 2026 eVolve MEP, LLC

import { ActionIcon, Indicator } from '@mantine/core';
// oxlint-disable-next-line no-restricted-imports
import { useNavigate } from 'react-router';

import type { NavbarFooterItemProps } from 'app/Layout/NavBar/NavBarContent/NavBarFooter';
import { navbarTransitionStyle } from 'app/Layout/NavBar/useAppShell';
import { useMessages } from 'app/MessageCenter/MessagesContext';
import { EvolveIcon } from 'assets/icons/EvolveIcon';

export const MailButton = (_: NavbarFooterItemProps) => {
  // useEvolveNavigate only works inside Shop routes
  const navigate = useNavigate();
  const goToMessageCenter = () => navigate('/message');
  const { totalUnread } = useMessages();

  return (
    <ActionIcon
      className="nav-link-icon-collapsed"
      onClick={goToMessageCenter}
      color="gray"
      size="input-sm"
      style={{
        'transition': navbarTransitionStyle,
        'overflow': 'visible',
        '--ai-hover': 'var(--mantine-color-app-shell-gray-7)',
      }}
    >
      <Indicator
        color="red"
        inline
        label={totalUnread > 999 ? '999+' : totalUnread}
        disabled={totalUnread === 0}
        size={12}
        styles={{ indicator: { fontSize: 11 } }}
      >
        <EvolveIcon icon="Message" />
      </Indicator>
    </ActionIcon>
  );
};
